import React, { useEffect, useContext, useState } from "react";
import "./App.scss";
import Trawka from "./components/Trawka/Trawka";
import ScrollContainer from "react-indiana-drag-scroll";
import PrismaZoom from "react-prismazoom";
import { BuildingsContext } from "./bContext";
import megaphone from "./assets/volumee.svg";
import mic from "./assets/karaoke.svg";
import glowa from "./assets/glowanew.gif";
import glowagada from "./assets/glowa_gadanew.gif";
import Sound from "react-sound";

function App() {
  const [volView, setVolView] = useState(false);
  const [volView2, setVolView2] = useState(false);
  const {
    checkShowing,
    which,
    setWhich,
    autoPre,
    setAutoPre,
    speakVol,
    setSpeakVol,
    setMusicVol,
    musicVol,
    modalPlaying,
    setModalPlaying,
    switchToEnglish,
    pageRoad,
  } = useContext(BuildingsContext);

  useEffect(() => {
    if (speakVol === 0) {
      setModalPlaying(false);
    }
  }, [modalPlaying, setModalPlaying, speakVol]);

  // useEffect(() => {
  //   window.scrollTo(500, 500)
  // },[])
  const {
    width,
    setWidth,
    height,
    setHeight,
    bs,
    setBs,
    rangeValue,
    setRangeValue,
    repeat,
    setRepeat,
  } = useContext(BuildingsContext);

  useEffect(() => {
    let sc = document.getElementsByClassName("scroll-container")[0];

    let ww = window.innerWidth;
    let wh = window.innerHeight;

    sc.scrollTo({
      left: (width - ww) / 2,
      top: (height - wh) / 2,
    });
  }, []);

  const zoom = (newRangeValue) => {
    let diff = newRangeValue - rangeValue;
    let condition = false;
    let ratio = 0;

    if (diff < 0) {
      if (width > 2400) {
        condition = true;
      }
      ratio = 1 / 1.25;
    } else if (diff > 0) {
      if (width < 7200) {
        condition = true;
      }

      ratio = 1.25;
    }
    // console.log(newRangeValue, rangeValue, ratio, width);

    if (ratio) {
      let nw = condition ? Math.round(width * ratio) : width;
      let nh = condition ? Math.round(height * ratio) : height;
      let nbs = condition ? Math.round(bs * ratio) : bs;

      setBs(nbs);
      setWidth(nw);
      setHeight(nh);
      setRangeValue(newRangeValue);

      let sc = document.getElementsByClassName("scroll-container")[0];

      sc.scrollTo({
        left: sc.scrollLeft * ratio, // (nw-ww)/2,
        top: sc.scrollTop * ratio, //(nh-wh)/2,
      });
    }
  };

  return (
    <div id="app" className="App">
      <header className="App-header"></header>
      <ScrollContainer className="scroll-container" nativeMobileScroll={false}>
        <Trawka />
      </ScrollContainer>

      {/* ========================PLUS================================ */}
      <div className="plusminus">
        <div
          className="plus"
          onClick={() => {
            if (rangeValue < 4) {
              zoom(parseInt(rangeValue) + 1);
            }
          }}
        >
          <div className="plus-small">+</div>
        </div>

        {/* ========================RANGE============================== */}
        {/* <div className="range-cont"> */}

        <input
          className="range vertical-lowest-first round"
          onChange={(e) => {
            // console.log(e.target.value);
            zoom(e.target.value);

            // console.log(e.target.value)
            // setRangeValue(e.target.value);
            // e.stopPropagation();
            // let nw = width > 7200 ? width : Math.round(width * 1.25);
            // let nh = width > 7200 ? height : Math.round(height * 1.25);
            // let nbs = width > 7200 ? bs : Math.round(bs * 1.25);

            // setBs(nbs);
            // setWidth(nw);
            // setHeight(nh);
            // setRangeValue(e.target.value);
          }}
          // onMouseMove={
          //   (e) => {
          //     console.log(e.target.value);
          //     setRangeValue(e.target.value);
          //     e.stopPropagation();
          //   }
          // }
          // onInput={(e) => {
          //   e.stopPropagation();
          // }}
          type="range"
          min="0"
          max="4"
          id="vol"
          name="vol"
          value={rangeValue}
        ></input>
        {/* <label htmlFor="vol"></label> */}
        {/* <label for="vol"></label> */}
        {/* </div> */}
        <hr className="border-dashed"></hr>

        {/* ========================MINUS================================ */}
        <div
          className="minus"
          onClick={() => {
            if (rangeValue >= 1) {
              zoom(rangeValue - 1);
            }

            // let nw = width > 2400 ? Math.round(width / 1.25) : width;
            // let nh = width > 2400 ? Math.round(height / 1.25) : height;
            // let nbs = width > 2400 ? Math.round(bs / 1.25) : bs;
            // setBs(nbs);
            // setWidth(nw);
            // setHeight(nh);
            // setRangeValue( rangeValue - 1 );

            // let sc = document.getElementsByClassName("scroll-container")[0];
            // console.log("new: ", nw, nh);

            // console.log("okno:", window.innerWidth, window.innerHeight);
            // console.log("offset przed:", sc.scrollLeft, sc.scrollTop);
            // console.log("szerokosc przed:", sc.scrollWidth, sc.scrollHeight);

            // sc.scrollTo({
            //   left: sc.scrollLeft / 1.25, // (nw-ww)/2,
            //   top: sc.scrollTop / 1.25, //(nh-wh)/2,
            // });
            // console.log("offset po:", sc.scrollLeft, sc.scrollTop);
          }}
        >
          <div className="plus-small">-</div>
        </div>
      </div>

      {/* =================================mic-speaker=========================== */}

      <div className="vol">
        <div
          className="mic-input"
          onMouseLeave={() => {
            setVolView(false);
          }}
        >
          <div
            className="button-big2 hov"
            onMouseOver={() => {
              setVolView(true);
            }}
            onClick={() => {
              if (speakVol > 0) {
                setSpeakVol(0);
              } else {
                setSpeakVol(90);
              }
            }}
          >
            <span className="button-small2">
              <img src={mic} alt="mic" />
            </span>
          </div>

          {volView && (
            <div className="button-big5 ">
              <span className="button-small5">
                <input
                  className=" vertical-lowest-first "
                  type="range"
                  id="mic"
                  name="mic"
                  min="0"
                  max="100"
                  step="5"
                  value={speakVol}
                  onChange={(e) => setSpeakVol(e.target.value)}
                />
              </span>
            </div>
          )}
        </div>

        <div
          className="speaker-input"
          onMouseLeave={() => {
            setVolView2(false);
          }}
        >
          <div
            className="button-big2"
            onMouseOver={() => {
              setVolView2(true);
            }}
            onClick={() => {
              if (musicVol > 0) {
                setMusicVol(0);
              } else {
                setMusicVol(90);
              }
            }}
          >
            <span className="button-small2">
              <img src={megaphone} alt="megaphone" />
            </span>
          </div>
          {volView2 && (
            <div className="button-big5 ">
              <span className="button-small5">
                <input
                  className=" vertical-lowest-first "
                  type="range"
                  id="megaphone"
                  name="megaphone"
                  min="0"
                  max="100"
                  step="5"
                  value={musicVol}
                  onChange={(e) => setMusicVol(e.target.value)}
                />
              </span>
            </div>
          )}
        </div>
      </div>
      {pageRoad !== 3 && (
        <div className="glowa">
          <div className="glowa-cont">
            {modalPlaying ? (
              <img className="gl" src={glowagada} alt="" />
            ) : (
              <img className="gl" src={glowa} alt="" />
            )}
          </div>

          {/* <img src={glowagada} alt="" /> */}
          {/* <img className="glowa" src={glowa} alt="" /> */}
        </div>
      )}

      <div className="autoprezentacja">
        <div
          className={autoPre === true ? "button-big active" : "button-big"}
          onClick={() => {
            setAutoPre(!autoPre);
          }}
        >
          <span
            className={
              autoPre === true ? "button-small3 active2" : "button-small3"
            }
          >
            {/* <p className="aut">AUTO</p> */}
            <p className="autoprez">
              {switchToEnglish === false
                ? "AUTOPREZENTACJA"
                : "SELF-PRESENTATION"}
            </p>
            <div className={autoPre === true ? "led-green" : "led-red"}></div>
          </span>
        </div>
      </div>
    </div>
  );
}

export default App;
